import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ClusterContactsService, ClusterContactUpdateDto } from 'src/api/v2';

import { CONTACT_KEY, CONTACTS_KEY } from 'src/constants/hook-keys';

import useCluster from '../../cluster/hooks/use-cluster';

export default function useContact(contactId: string | undefined = '') {
  const { cluster } = useCluster();

  const [service] = useState(new ClusterContactsService());

  const queryClient = useQueryClient();

  const { data: contact, ...rest } = useQuery({
    queryKey: [CONTACT_KEY, contactId],
    queryFn: () => service.getContact(contactId),
    enabled: !!cluster && !!contactId,
  });

  const updateMutation = useMutation({
    mutationFn: (record: ClusterContactUpdateDto) => {
      return service.updateContact(contactId, record);
    },
    onSuccess(data) {
      queryClient.setQueryData([CONTACT_KEY, contactId], data);
      queryClient.resetQueries([CONTACTS_KEY]);
    },
  });

  return {
    contact,

    ...rest,

    updateMutation,
  };
}
